import * as React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import Typography from '@material-ui/core/Typography/Typography';

import StaticPage from 'client/components/pages/StaticPage';

const TermsOfUsePage: React.FunctionComponent<RouteComponentProps> = () => (
	<StaticPage title="ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ">
		<Typography gutterBottom>Дата редакции 01.09.2021</Typography>
		<Typography gutterBottom>
			Настоящий документ является офертой Общества с ограниченной ответственностью «КСеть»
			(ИНН: 7724818587, ОГРН: 1127746004693), именуемого далее также Администрация, о
			заключении соглашения об использовании сервиса PRTV.SU (Сайт, Сервис) на изложенных ниже
			условиях. Оферта адресована юридическим и физическим лицам.
		</Typography>
		<Typography gutterBottom>
			Лицо, акцептовавшее оферту и соответствующее изложенным требованиям, именуется далее
			также Пользователем, при этом Администрация и Пользователь совместно именуются
			Сторонами, а заключённое между ними соглашение — Соглашением.
		</Typography>
		<Typography gutterBottom>
			Соглашение считается заключенным и приобретает силу договора присоединения с момента
			совершения Пользователем действий по акцепту настоящего Соглашения.
		</Typography>
		<Typography gutterBottom>
			Пользователь обязан полностью ознакомиться с настоящим Соглашением до момента
			пользования Сервисом. Если Пользователь не принимает условия настоящего Соглашения, он
			должен немедленно отказаться от использования Сервиса.
		</Typography>

		<Typography gutterBottom>
			<ol className="simpleList">
				<li>
					<Typography variant="h6" gutterBottom align="left">
						ПРЕДМЕТ СОГЛАШЕНИЯ
					</Typography>
					<ol>
						<li>
							Обращение к любому из разделов Сервиса, начало его использования или
							использования отдельной его функции подразумевают юридически обязывающее
							согласие Пользователя на соблюдение условий и положений настоящего
							Соглашения (акцепт).
						</li>

						<li>
							Сервис представляет собой комплекс программно-технических возможностей
							по созданию Пользователем слайд-шоу для запуска на телевизорах с
							функцией Smart TV, марок LG, Samsung, моделей и приставок на базе
							операционной системы Android и Android TV.
						</li>

						<li>
							Пользователь имеет возможность разместить в слайдах отдельные виджеты,
							предлагаемые для размещения Сервисом: прогноз погоды, информацию об
							автомобильных пробках, трансляцию видео из YouTube, отображение
							сообщений из групп различных социальных сетей, фото, текст и иную
							информацию по своему выбору.
						</li>
						<li>
							Пользователь сам подбирает нужный для себя контент и виджеты и размещает
							их в слайдах.
						</li>
						<li>
							Использование функциональных возможностей Сайта и/или предоставляемого
							на его основе Сервиса в ограниченной части возможно без прохождения
							Пользователем предварительной регистрации и/или авторизации на Сайте.
						</li>
						<li>
							В остальной части применение функциональных возможностей Сайта и/или
							предоставляемого на его основе Сервиса допускается после прохождения
							Пользователем регистрации на Сайте в соответствии с установленными
							Администрацией правилами.
						</li>
						<li>
							Перечень функциональных возможностей Сайта и предоставляемого на его
							основе Сервиса определяется по единоличному усмотрению Администрации и
							может время от времени изменяться.
						</li>
						<li>
							Технические, организационные и коммерческие условия использования Сайта
							и основанного на нем Сервиса могут доводиться до сведения Пользователей
							путем отдельного размещения на Сайте или путем нотификации
							Пользователей.
						</li>
					</ol>
				</li>
				<li>
					<Typography variant="h6" gutterBottom align="left">
						РЕГИСТРАЦИЯ ПОЛЬЗОВАТЕЛЯ
					</Typography>
					<ol>
						<li>
							Пользователь, желающий воспользоваться услугами, должен пройти процедуру
							регистрации. Регистрация на Сервисе является бесплатной и доступна для
							всех Пользователей.
						</li>

						<li>
							При использовании Сервиса Пользователь обязуется предоставлять
							достоверную и полную информацию о себе по вопросам, предлагаемым в форме
							регистрации и/ или авторизации на Сайте, при заключении договора с
							использованием его программных средств, и при необходимости поддерживать
							эту информацию в актуальном состоянии. Если Пользователь предоставляет
							неверную информацию или у Администрации есть основания полагать, что
							предоставленная Пользователем информация неполна или недостоверна,
							Администрация имеет право по своему усмотрению заблокировать либо
							удалить Личный кабинет Пользователя, а также отказать Пользователю в
							заключении и/или исполнении договора, и ином использовании Сервиса
							полностью или в определенной части.
						</li>

						<li>
							Каждый Пользователь может пройти процедуру регистрации только один раз.
							Регистрация нескольких аккаунтов не допускается. При регистрации
							Пользователю присваивается логин и пароль. Пользователь самостоятельно
							несет ответственность за сохранность логина и пароля.
						</li>
						<li>
							Администрация не несет ответственности за разглашение логина и пароля
							Пользователя третьим лицам и в случае несанкционированного доступа
							третьих лиц к аккаунту Пользователя.
						</li>
						<li>
							Администрация вправе заблокировать доступ Пользователя к Сервису,
							заблокировать или удалить учетную запись Пользователя на Сервисе без
							возможности ее восстановления.
						</li>
					</ol>
				</li>
				<li>
					<Typography variant="h6" gutterBottom align="left">
						УСЛОВИЯ ПОЛЬЗОВАНИЯ СЕРВИСОМ
					</Typography>
					<ol>
						<li>
							Все объекты Сервиса, в том числе элементы дизайна, текст, графические
							изображения, другие объекты, а также любой контент, размещенный на
							Сервисе, являются объектами исключительных прав Администрации,
							Пользователей и других правообладателей соответственно.
						</li>

						<li>
							Материалы Сервиса, а также любой контент, размещенные на Сервисе, не
							могут быть использованы без предварительного разрешения правообладателя.
						</li>

						<li>
							Использование Пользователем материалов, а также любого контента в
							личных, некоммерческих целях, возможно при условии сохранения всех
							знаков охраны авторского права, товарных знаков, и сохранении
							соответствующего объекта в неизменном виде. Исключение составляют
							случаи, прямо предусмотренные законодательством или настоящим
							Соглашением.
						</li>
						<li>
							Запрещается любое незаконное использование настоящего Сервиса,
							размещенной на нем информации и иных материалов.
						</li>
						<li>
							Пользователям запрещается использование Сервиса для:
							<ol>
								<li>
									распространения запрещенных или ограниченных в обороте товаров;
								</li>

								<li>
									распространения материалов порнографического характера, а равно
									связанных с пропагандой порнографии и рекламой интимных услуг;
								</li>

								<li>
									распространения любой иной запрещенной информации, включая
									материалы экстремистского характера, а также направленных на
									ущемление прав и свобод человека по признакам расовой и
									национальной принадлежности, вероисповедания, языка, и пола,
									подстрекающие к совершению насильственных действий в отношении
									человека, либо к бесчеловечному обращению с животными,
									призывающие к совершению иных противоправных действий, в том
									числе разъясняющие порядок изготовления и применения оружия,
									наркотических средств и их прекурсоров, и т.д.;
								</li>
								<li>
									распространения недостоверной информации, порочащей честь
									достоинство или деловую репутацию третьих лиц;
								</li>
								<li>
									совершения иных противоправных действий, включая получение
									несанкционированного доступа к конфиденциальной информации, ее
									распространение, неправомерный доступ к компьютерной информации,
									использование и распространение вредоносных компьютерных
									программ, нарушение правил эксплуатации средств хранения,
									обработки или передачи компьютерной информации, организации
									азартных игр, проведения лотерей и иных стимулирующих
									мероприятий в нарушение действующего законодательства.
								</li>
							</ol>
						</li>
						<li>
							Пользователи несут исключительную ответственность за любое нарушение
							обязательств, установленных настоящим Соглашением и/или применимым
							правом, а также за все последствия таких нарушений (включая любые убытки
							или ущерб, которые может понести Администрация и иные третьи лица).
						</li>
						<li>
							Администрация устраняется от какой бы то ни было ответственности в связи
							с допущенными Пользователем нарушениями, а также причинением
							Пользователю вреда или убытков при указанных выше обстоятельствах.
						</li>
					</ol>
				</li>
				<li>
					<Typography variant="h6" gutterBottom align="left">
						ПРАВА И ОБЯЗАННОСТИ СТОРОН
					</Typography>
					<ol>
						<li>
							Пользователь обязуется:
							<ol>
								<li>
									При работе с Сервисом не нарушать действующее законодательство,
									в том числе в сфере интеллектуальной собственности, авторских
									и/или смежных правах, не использовать Сервис в противоправных
									целях.
								</li>

								<li>
									Не распространять любые материалы и произведения, являющиеся
									объектами интеллектуальных прав без согласия правообладателей.
								</li>
								<li>
									Не копировать (воспроизводить) в любой форме и способом входящие
									в состав Сайта программы для ЭВМ и базы данных, включая любые их
									элементы и Контент, без получения предварительного письменного
									согласия их владельца;
								</li>
								<li>
									Не вскрывать технологию, не эмулировать, не декомпилировать, не
									дизассемблировать, не дешифровать, и не производить иные
									аналогичные действия с Сайтом;
								</li>
								<li>
									Не создавать программные продукты и/или сервисы с использованием
									Сервиса без получения предварительного разрешения Администрации.
								</li>
							</ol>
						</li>

						<li>
							Пользователь имеет право:
							<ol>
								<li>
									Доступа к Сервису в любое время, кроме времени проведения
									профилактических работ и сбоев, не зависящих от воли
									Администрации.
								</li>

								<li>
									Пользоваться Сервисом в пределах его функциональных возможностей
									и на условиях, установленных настоящим Соглашением.
								</li>
							</ol>
						</li>
						<li>
							Администрация обязуется:
							<ol>
								<li>Предоставлять Пользователю доступ к Сервису.</li>

								<li>
									Предоставлять Пользователю полную и достоверную информацию о
									Сервисе по его требованию.
								</li>

								<li>
									Осуществлять техническую поддержку Пользователя, в том числе по
									вопросам, связанным с функциональностью Сервиса и
									предоставляемыми услугами, а также особенностями эксплуатации
									Сервиса.
								</li>
								<li>
									Обеспечивать работу Сервиса, в соответствии с условиями
									настоящего Соглашения.
								</li>
							</ol>
						</li>

						<li>
							Администрация имеет право:
							<ol>
								<li>
									Изменять Сервис, его содержание, функциональные возможности и
									пользовательский интерфейс по своему усмотрению.
								</li>

								<li>Изменять условия Соглашения в одностороннем порядке.</li>

								<li>
									Приостановить работу Сервиса в любое время без предварительного
									уведомления в целях обновления Сервиса, проведения
									профилактических работ, в случае технических сбоев, действием
									и/или бездействием третьих лиц и по иным причинам, не зависящим
									от Администрации.
								</li>
								<li>
									Приостановить доступ Пользователю в одностороннем внесудебном
									порядке, в случаях существенного нарушения Пользователем условий
									настоящего Соглашения, в том числе при наличии признаков
									разжигания конфликтов, содержании в нецензурной брани,
									пропаганды насилия, жестокости, экстремизма, ненависти и (или)
									дискриминацию по расовому, национальному, половому,
									религиозному, социальному признакам и пр., а также в случае
									поступления жалобы от третьих лиц о нарушении Пользователем
									исключительных прав на тот или иной контент.
								</li>
							</ol>
						</li>
						<li>
							Сервис предоставляется на условиях “как есть”, в связи с чем
							Пользователям не представляются какие-либо гарантии, что Сервис будет
							соответствовать их требованиям; услуги будут предоставляться непрерывно,
							быстро, надежно и без ошибок; результаты, которые могут быть получены с
							использованием Сервиса, будут точными и надежными; качество какого-либо
							продукта, услуги, информации, полученных с использованием Сервиса, будет
							соответствовать ожиданиям; все ошибки в программном обеспечении Сайта
							будут исправлены.
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ
					</Typography>
					<ol>
						<li>
							Администрация обязуется оказать Пользователю услугу или комплекс услуг
							по выбору Пользователя, а Пользователь обязуется принять и оплатить
							оказанные услуги в соответствии с условиями, указанными в настоящих
							правилах, в том числе, но не исключая:
							<ol>
								<li>
									дополнительная функциональность Сервиса по настройке показа
									слайд-шоу по заранее определенному расписанию (потока);
								</li>

								<li>предоставление статистики показов;</li>

								<li>
									использование платного хостинга для видеоматериалов (Vimeo);
								</li>
								<li>
									любые другие возмездные услуги, предложение о приобретении
									которых размещено Администрацией на Сайте.
								</li>
							</ol>
						</li>
						<li>
							Информация о возможности оказания соответствующей услуги, а также о
							наличии или отсутствии технических ограничений для оказания услуг
							сообщается Пользователю в переписке, решение о возможности или
							невозможности оказания услуги принимается Администрацией.
						</li>
						<li>
							Администрация вправе оказать услуги как лично, так и с привлечением
							третьих лиц, при этом за действия, выполняемые третьими лицами,
							Администрация несет ответственность, как за свои собственные.
						</li>
						<li>
							Пользователю обязан перечислить 100% стоимости услуг в виде предоплаты
							на реквизиты банковского счета Администрации. Дата зачисления денежных
							средств на расчетный счет Администрации признается Сторонами моментом
							выражения воли Пользователя на оказание услуг по настоящему Соглашению.
						</li>
						<li>
							Администрация вправе в любой момент отказаться от исполнения услуг при
							условии возврата Пользователю полученных от него денежных средств при
							наличии технической невозможности выполнения принятых на себя
							обязательств.
						</li>
						<li>
							Срок оказания услуги (тарифа, подписки), а также итоговая стоимость
							тарифа, сформированная в результате выбора Пользователем набора платных
							услуг, указывается на Сайте Сервиса до момента оплаты таких услуг.
						</li>
						<li>
							При осуществлении оплаты Пользователь вправе подключить регулярные
							автоматические платежи для продления права доступа без дополнительного
							одобрения каждого последующего платежа (рекуррентные платежи).
							Пользователь выражает согласие с подключением рекуррентных платежей при
							оформлении автоматической оплаты Сервиса с помощью возможностей Сайта.
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ОСОБЫЕ УСЛОВИЯ
					</Typography>
					Сервис может быть использован Пользователем в публичном месте, при этом
					Пользователь вправе:
					<ol>
						<li>
							Использовать контент, если он является правообладателем данного контента
							или ему предоставлено право использования такого контента на законных
							условиях.
						</li>
						<li>Показывать сообщения со своей страницы в социальной сети.</li>
						<li>
							Показывать со своей страницы в социальной сети свои или чужие материалы,
							которые носят исключительно информационный характер. Информационный
							характер носят, в том числе: сообщения о новостях дня, программы
							телепередач, прогноз погоды, и т.п. При этом использование графики,
							дизайна чужих материалов не допускается без письменного разрешения
							автора или правообладателя.
						</li>
						<li>
							Показывать со своей страницы в социальной сети авторский контент
							(тексты, фото, видео, музыку и т.п.), права на который принадлежат
							Пользователю.
						</li>
						<li>
							Показывать со своей страницы в социальной сети чужой авторский контент,
							если автор (правообладатель) явным образом выразил свое согласие на
							свободное использование контента любым лицом или правилами социальной
							сети предусмотрено свободное пользование контентом третьими лицами. При
							этом Пользователь обязуется самостоятельно предварительно
							ознакамливаться с такими правилами с целью недопущения нарушения прав
							третьих лиц.
						</li>
						<li>
							Показывать сообщения из всей социальной сети по хештегу, специально
							созданному Пользователем для идентификации тех сообщений, которые
							размещены в связи с деятельностью Пользователя.
						</li>
						<li>
							Использовать материалы и контент социальной сети иным способом по
							согласованию с владельцами страниц сайта, владельцами контента и
							администрацией сайта. Использование контента и материалов, содержащих
							чужие товарные знаки без разрешения владельцев товарных знаков не
							допускается.
						</li>
						<li>
							Показывать новости в формате RSS, если пользовательское соглашение сайта
							допускает свободное использование таких материалов или если Пользователь
							получил письменное согласие владельца сайта на использование материалов
							и контента сайта.
						</li>
						<li>
							Пользователь осознает, что трансляция (общественный показ) видеоролика в
							коммерческих целях с логотипом конкретного телеканала, музыкального
							видеоклипа, иного контента может быть расценено телеканалом,
							правообладателем как прямое нарушение его исключительных прав.
						</li>
						<li>
							Пользователь принимает, что правообладатель может по своему усмотрению
							разрешать или запрещать другим лицам использование результата
							интеллектуальной деятельности или средства индивидуализации. Отсутствие
							запрета не считается согласием (разрешением) (ст. 1229 ГК РФ).
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ПОЛИТИКА ВОЗВРАТА
					</Typography>
					<ol>
						<li>
							Администрация вправе отказаться от исполнения настоящего соглашения в
							том случае если Пользователь предоставляет материалы, запрещенные для
							распространения или нарушающие авторские и исключительные права третьих
							лиц с условием возврата Пользователю 100% полученной от него предоплаты
							за оказание услуг.
						</li>
						<li>
							Администрация вправе в любой момент отказаться от исполнения услуг при
							условии возврата Пользователю 100% полученной от него предоплаты за
							оказание услуг при наличии технической невозможности выполнения принятых
							на себя обязательств.
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						КОНФИДЕНЦИАЛЬНОСТЬ
					</Typography>
					<ol>
						<li>
							Администрация обязуется соблюдать конфиденциальность личной и
							персональной информации Пользователей.
						</li>
						<li>
							Порядок осуществления сбора, обработки, использования и раскрытия
							персональных данных Пользователя, а также порядок удаления, уничтожения
							персональных данных Пользователя указан в
							<a href="https://prtv.su/privacy-policy">
								«Политике обработки персональных данных»
							</a>
							, являющейся неотъемлемой частью настоящего Соглашения.
						</li>
						<li>
							Пользователь может в любой момент отозвать свое согласие на обработку
							персональных данных, направив Оператору письмо-уведомление посредством
							электронной почты на электронный адрес Оператора{' '}
							<a href="mailto:info@prtv.su">info@prtv.su</a> с пометкой «Отзыв
							согласия на обработку персональных данных».
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ОТВЕТСТВЕННОСТЬ СТОРОН
					</Typography>
					<ol>
						<li>
							Администрация не подтверждает и не несет ответственности за точность
							контента, полученного Администрацией из внешних источников, не
							относящихся к Администрации и не контролируемых ею.
						</li>
						<li>
							Администрация отказывается (не предоставляет) от всех гарантий любого
							вида, явных, предполагаемых или законных в отношении Сервиса, включая
							гарантии правового характера, пригодности для конкретных целей или
							отсутствия нарушения прав третьих лиц.
						</li>
						<li>
							Администрация не несет никакой ответственности за действия Пользователя
							перед третьими лицами и другими Пользователями.
						</li>
						<li>
							Администрация не возмещает никакие убытки, которые Пользователь может
							понести в случае умышленного или неосторожного нарушения любого
							положения настоящего Соглашения.
						</li>
						<li>
							Сервис не предназначен для Пользователей, не достигших 18 лет.
							Администрация Сервиса не несет ответственности за какие-либо
							нежелательные последствия в случае неисполнения настоящего требования
							Пользователями.
						</li>
						<li>
							Пользователь соглашается, что использует Сервис на свой собственный
							риск, включая оценку его надежности, полноты или полезности.
						</li>
						<li>
							Пользователь понимает и соглашается с тем, что получая материалы
							посредством использования Сервиса по своему собственному усмотрению и на
							свой риск, будет нести единоличную ответственность за любые негативные
							последствия.
						</li>
						<li>
							Пользователь согласен с тем, что если при использовании Сервиса будет
							транслироваться аудио-произведения для посетителей его заведения, то по
							смыслу действующего законодательства РФ Пользователь, как владелец
							такого заведения, выступает лицом, организующим публичное исполнение
							фонограмм, опубликованных в коммерческих целях, что недопустимо без
							выплаты вознаграждения правообладателям.
						</li>
						<li>
							Администрация и Пользователь освобождаются от ответственности в связи
							предоставлением права использования Сервиса в случае наступления
							форс-мажорных обстоятельств в смысле и толковании, изложенном в
							международных нормативных актах.
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ
					</Typography>
					<ol>
						<li>
							В случае возникновения споров и разногласий в связи с исполнением
							настоящего Соглашения и использования Сервиса, такие споры должны
							решаться путем переговоров между Пользователем и Администрацией, срок
							которых не будет превышать 30 (тридцать) календарных дней с даты
							получения первоначального уведомления соответствующей стороной.
						</li>
						<li>
							В случае не достижения согласия между сторонами по спорным вопросам, все
							споры и разногласия должны рассматриваться компетентным судом по месту
							нахождения Администрации.
						</li>
					</ol>
				</li>

				<li>
					<Typography variant="h6" gutterBottom align="left">
						ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
					</Typography>
					<ol>
						<li>Соглашение действует бессрочно.</li>
						<li>
							Пользователь вправе прекратить соглашение путём прекращения
							использования Сервиса.
						</li>
						<li>
							В случае отзыва настоящего Соглашения в течение срока его действия
							настоящее Соглашение считается прекращенным с момента отзыва. Отзыв
							осуществляется путем размещения соответствующей информации на Сервисе.
						</li>
						<li>
							Настоящее Соглашение регулируется законодательством Российской
							Федерации.
						</li>
						<li>
							Администрация оставляет за собой право в одностороннем порядке вносить
							изменения в настоящее Соглашение. Изменения вступают в силу с момента
							публикации, если иной срок отдельно не оговорен.
						</li>
					</ol>
				</li>
			</ol>
		</Typography>
	</StaticPage>
);

export default TermsOfUsePage;
